import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CloudLightningIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="rain-texture relative isolate overflow-hidden" data-id="element-82" data-mp="s9ghk1uwwk98">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-83" data-mp="nb6n5th0hnoo">
        <span className="flex-1 bg-primary" data-id="element-84" data-mp="3d1ihv20l0yjq" />
        <span className="glow-line w-24 bg-highlight" data-id="element-85" data-mp="3d2birmcv0tty" />
        <span className="flex-1 bg-primary" data-id="element-86" data-mp="382p6pg8rpjmq" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-87" data-mp="3814alm6t1smr">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-accent/50 bg-surface/70 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-foreground" data-id="element-88" data-mp="3j9265qny7uwl">
          <CloudLightningIcon className="glow-led h-4 w-4 text-highlight" aria-hidden="true" data-id="element-89" data-mp="30hrev8eb9g46" /> {productBrand}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-8 max-w-3xl" data-id="element-90" data-mp="35aas2493698g">
          <div className="storm-halo pointer-events-none absolute inset-[-8%] -z-10" aria-hidden="true" data-id="element-91" data-mp="2hk886bfbs9kx" />
          <img src={productImage} alt={productImageAlt} className="mockup-glow mx-auto w-full" data-id="element-92" data-mp="2ljgzzaqt1xdu" />
        </motion.div>

        <div className="mt-9" data-id="element-93" data-mp="s3cmudv0pps5">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-94" data-mp="nbb9spq0zv12">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-95" data-mp="icrsj2mdn7f1">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-primary/60 bg-surface/70 px-3 py-2" data-id="element-96" data-mp="1azuktd0gmlwu">
              <Icon className="glow-led h-3.5 w-3.5 text-highlight" aria-hidden="true" data-id="element-97" data-mp="162lyd08a3vps" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}